/**
 * 数値を日本の郵便番号形式へ変換します。
 *
 * @param {zipCode} num 数値
 * @returns {string} xxx-xxxx...に変換された文字列
 */
export function format(zipCode) {
  return zipCode ? zipCode.replace(/(^\d{3})(\d+)/, '$1-$2') : ''
}
